module.exports = __webpack_public_path__ + "img/CMendes@2x.47fa19c7.png";